import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics"; // 1. Import getAnalytics

//
// NO OTHER IMPORTS FROM YOUR PROJECT SHOULD BE HERE.
// e.g., NO 'import Header from "./Components/Header"' etc.
//

// Your Firebase config
const firebaseConfig = {
   apiKey: "AIzaSyCr5vthq-EZ_m_KO-3XHTRHK0OVZka3XNs",
  authDomain: "tovan-17b28.firebaseapp.com",
  projectId: "tovan-17b28",
  storageBucket: "tovan-17b28.appspot.com",
  messagingSenderId: "809666785908",
  appId: "1:809666785908:web:4ba9d4e3b3ce65d791d721",
  measurementId: "G-S0NGGPKJV1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export services
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app); // 2. Initialize Analytics

export { db, auth, analytics }; // 3. Export analytics (optional but good practice)